export default __webpack_public_path__ + "assets/c243c70960fc65b1dccbe2160d67aedd.png";